// extracted by mini-css-extract-plugin
export default {"modal":"sign-request-in-portal-modal_modal__WxPrT","iframe":"sign-request-in-portal-modal_iframe__CkddN"};